export default str => parseFloat(str.replace(/,/g, ''));
